
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 14.167c-1.395 0-2.609 1.054-3.235 2.609-.3.743.13 1.557.7 1.557h5.07c.57 0 1-.814.7-1.557-.626-1.555-1.84-2.61-3.235-2.61z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M15.417 4.167h1.002c1 0 1.5 0 1.762.314.26.315.152.787-.065 1.73l-.326 1.417c-.49 2.13-2.28 3.713-4.457 4.039M4.583 4.167H3.581c-1 0-1.5 0-1.762.314-.26.315-.152.787.065 1.73l.326 1.417c.49 2.13 2.28 3.713 4.457 4.039","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 14.167c2.517 0 4.637-3.886 5.275-9.175.176-1.462.264-2.194-.203-2.76-.466-.565-1.22-.565-2.727-.565h-4.69c-1.507 0-2.26 0-2.727.565-.467.566-.379 1.298-.203 2.76.638 5.29 2.758 9.175 5.275 9.175z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    